<template>
  <div class="row">
    <div class="col-12">

      <div class="card pg-card mb-25 border-0 letter-spacing">
        <div
          class="card-head d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
        >
          <div class="d-sm-flex align-items-center">
            <button
              class="pg-btn-primary position-relative transition border-0 fw-medium text-white d-inline-flex align-items-center me-10 mb-10 mb-lg-0"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#createNewZoneModal"
              v-if="auth.can('SETTINGS')"
            >
              <i class="flaticon-plus position-relative fs-12 me-8"></i>
              Nouvelle zone
            </button>
            <button
              class="pg-btn-outline position-relative transition fw-medium d-inline-flex align-items-center mb-10 mb-lg-0"
              type="button"
            >
              <i class="flaticon-file-1 position-relative fs-15 me-8"></i>
              Export
            </button>
          </div>
          <div class="pg-search position-relative">
            <i class="flaticon-search pg-search-icon"></i>
            <input
              type="text"
              class="form-control ps-40"
              v-model="searchTerm"
              placeholder="Rechercher une zone..."
            />
          </div>
        </div>
        <div class="card-body p-0">
          <div class="table-scroll-outer">
            <div class="table-scroll-mobile">
              <table class="table pg-table text-nowrap align-middle mb-0">
                <thead>
                  <tr>
                    <th v-for="h in headers" :key="h.value">{{ h.text }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td :colspan="headers.length" class="text-center py-40">
                      <div class="spinner-border text-success" role="status">
                        <span class="visually-hidden">Chargement...</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-else-if="!pagedRows.length">
                    <td :colspan="headers.length" class="text-center py-40 text-muted">
                      <i class="flaticon-placeholder fs-40 d-block mb-10 opacity-25"></i>
                      Aucune zone trouvée
                    </td>
                  </tr>
                  <template v-else>
                    <tr v-for="row in pagedRows" :key="row.id">
                      <td>{{ row.ref }}</td>
                      <td class="fw-medium">{{ row.name }}</td>
                      <td class="text-wrap">
                        <div class="d-flex flex-wrap gap-6">
                          <span
                            class="status-pill status-pill-info"
                            v-for="(city, i) in row.cities"
                            :key="i"
                          >
                            {{ city?.name }}
                          </span>
                          <span v-if="!row.cities || !row.cities.length" class="text-muted fs-13">—</span>
                        </div>
                      </td>
                      <td>
                        <div class="switch">
                          <input
                            type="checkbox"
                            class="switch-input"
                            :id="'switch-stock-' + row.id"
                            :checked="row.stock"
                            @change="toggleZoneStock(row.id, $event.target.checked)"
                          />
                          <label class="switch-label" :for="'switch-stock-' + row.id"></label>
                        </div>
                      </td>
                      <td>
                        <div class="switch">
                          <input
                            type="checkbox"
                            class="switch-input"
                            :id="'switch-hub-' + row.id"
                            :checked="row.hub"
                            @change="toggleZoneHub(row.id, $event.target.checked)"
                          />
                          <label class="switch-label" :for="'switch-hub-' + row.id"></label>
                        </div>
                      </td>
                      <td>
                        <div class="switch">
                          <input
                            type="checkbox"
                            class="switch-input"
                            :id="'switch-' + row.id"
                            :checked="row.active"
                            @change="toggleZoneActive(row.id, $event.target.checked)"
                          />
                          <label class="switch-label" :for="'switch-' + row.id"></label>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex align-items-center gap-8" v-if="auth.can('SETTINGS')">
                          <router-link
                            :to="`/cities-zone-settings/${row.id}`"
                            class="pg-icon-btn pg-icon-btn-info"
                            title="Villes"
                          >
                            <i class="flaticon-placeholder"></i>
                          </router-link>
                          <button
                            type="button"
                            class="pg-icon-btn pg-icon-btn-edit"
                            title="Modifier"
                            @click="editZone(row.id)"
                          >
                            <i class="flaticon-pen"></i>
                          </button>
                          <button
                            type="button"
                            class="pg-icon-btn pg-icon-btn-delete"
                            title="Supprimer"
                            @click="deleteZone(row.id)"
                          >
                            <i class="flaticon-delete"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <div class="px-15 px-md-20 pb-15 border-top">
            <PaginatorContent :pagination="pager" :offset="3" @paginate="goToPage" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="createNewZoneModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content pg-modal-content">
        <div class="modal-header pg-modal-header">
          <div class="d-flex align-items-center">
            <span class="pg-modal-icon">
              <i class="flaticon-placeholder"></i>
            </span>
            <h5 class="modal-title ms-12 mb-0">Nouvelle zone</h5>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitZone">
            <div class="row g-10">
              <div class="col-md-6">
                <div class="form-group mb-20">
                  <label class="d-block text-black fw-medium mb-10">
                    Réference de la zone
                  </label>
                  <input
                    type="text"
                    v-model="newZone.reference"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-20">
                  <label class="d-block text-black fw-medium mb-10">
                    Nom de la zone
                  </label>
                  <input
                    type="text"
                    v-model="newZone.name"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer pg-modal-footer">
          <button
            type="button"
            class="pg-btn-outline transition fw-medium"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button type="button" @click="submitZone" class="pg-btn-primary border-0 transition fw-medium">
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="editZoneModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content pg-modal-content">
        <div class="modal-header pg-modal-header">
          <div class="d-flex align-items-center">
            <span class="pg-modal-icon">
              <i class="flaticon-pen"></i>
            </span>
            <h5 class="modal-title ms-12 mb-0">Modifier zone</h5>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitEditZone">
            <div class="row g-10">
              <div class="col-md-6">
                <div class="form-group mb-20">
                  <label class="d-block text-black fw-medium mb-10">
                    Réference de la zone
                  </label>
                  <input
                    type="text"
                    v-model="formZone.reference"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-20">
                  <label class="d-block text-black fw-medium mb-10">
                    Nom de la zone
                  </label>
                  <input
                    type="text"
                    v-model="formZone.name"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer pg-modal-footer">
          <button
            type="button"
            class="pg-btn-outline transition fw-medium"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button type="button" @click="submitEditZone" class="pg-btn-primary border-0 transition fw-medium">
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { Modal } from "bootstrap";
import { onMounted, reactive, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useClientTable } from "@/composables/useClientTable";

export default {
  name: "ZonesContent",
  setup: () => {
    const auth = useAuthStore();
    const { showToast } = useAppToast();
    const themeColor = "#06b48a";
    const searchTerm = ref("");

    const newZone = reactive({
      reference: "",
      name: "",
    });

    const formZone = reactive({
      reference: "",
      name: "",
      id: "",
    });
    const headers = [
      { text: "Code", value: "ref" },
      { text: "Nom", value: "name" },
      { text: "Villes", value: "cities" },
      { text: "Stock", value: "stock" },
      { text: "Hub", value: "hub" },
      { text: "Statut", value: "active" },
      { text: "Actions", value: "actions" },
    ];

    const zones = ref([]);
    const loading = ref(true);
    const { pagedRows, pager, goToPage } = useClientTable(zones, searchTerm);

    onMounted(async () => {
      fetchZones();
    });

    async function submitZone() {
      if (!newZone.reference || !newZone.name) {
        showToast("Please fill in all fields!", "error");
        return;
      }

      try {
        // Example: send to API
        const response = await api.post("/api/auth/zone_add", {
          ref: newZone.reference,
          name: newZone.name,
        });

        if (response.data.message == "success") {
          const modalEl = document.getElementById("createNewZoneModal");
          const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
          modal.hide();
          fetchZones();
          this.newZone = {
            reference: "",
            name: "",
          };
          showToast("Zone added successfully!", "success");
          //   closeModal();
          // get zones list refresh
        } else {
          showToast("Error: " + response.data.message, "error");
        }
      } catch (error) {
        console.error(error);
        showToast("An error occurred while adding the zone.", "error");
      }
    }

    async function fetchZones() {
      loading.value = true;
      try {
        const response = await api.get("/api/auth/zone_list");
        if (response && response.data) {
          // handle the fetched zones data
          // console.log("Fetched zones:", response.data);
          zones.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching zones:", error);
      } finally {
        loading.value = false;
      }
    }
    async function toggleZoneActive(id, value) {
      const zone = zones.value.find((z) => z.id === id);
      if (zone) {
        zone.active = value;
        // Optionally, send update to API here
        const res = await api.post(`/api/auth/active_zone/${id}`, {
          active: value,
        });
        console.log("Zone active status updated:", res.data);
      }
    }

    async function toggleZoneStock(id, value) {
      const zone = zones.value.find((z) => z.id === id);
      if (zone) {
        zone.stock = value;
        const res = await api.post(`/api/auth/stock_zone/${id}`, {
          active: value,
        });
        console.log("Zone active status updated:", res.data);
      }
    }
    async function toggleZoneHub(id, value) {
      const zone = zones.value.find((z) => z.id === id);
      if (zone) {
        zone.hub = value;
        const res = await api.post(`/api/auth/hub_zone/${id}`, {
          active: value,
        });
        console.log("Zone active status updated:", res.data);
      }
    }
    function editZone(id) {
      const zone = zones.value.find((z) => z.id === id);
      if (zone) {
        formZone.reference = zone.ref;
        formZone.name = zone.name;
        formZone.id = zone.id;
      }

      const modalEl = document.getElementById("editZoneModal");
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      modal.show();
    }
    async function deleteZone(id) {
      if (confirm("Are you sure you want to delete this city?")) {
        try {
          const response = await api.post(`/api/auth/removeZone/${id}`);
          if (response.data.message === "success") {
            // Remove the city from the local list
            fetchZones();
            showToast("Zone deleted successfully!", "success");
          } else {
            showToast("Error deleting zone: " + response.data.message, "error");
          }
        } catch (error) {
          console.error(error);
          showToast("An error occurred while deleting the zone.", "error");
        }
      }
    }
    async function submitEditZone() {
      if (!formZone.reference || !formZone.name) {
        showToast("Please fill in all fields!", "error");
        return;
      }

      try {
        // Example: send to API
        const response = await api.post(`/api/auth/zone_edit/${formZone.id}`, {
          id: formZone.id,
          ref: formZone.reference,
          name: formZone.name,
        });

        if (response.data.message == "success") {
          const modalEl = document.getElementById("editZoneModal");
          const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
          modal.hide();
          fetchZones();
          formZone.reference = "";
          formZone.name = "";
          formZone.id = "";
          showToast("Zone updated successfully!", "success");
          //   closeModal();
          // get zones list refresh
        } else {
          showToast("Error: " + response.data.message, "error");
        }
      } catch (error) {
        console.error(error);
        showToast("An error occurred while updating the zone.", "error");
      }
    }
    return {
      newZone,
      submitZone,
      headers,
      zones,
      pagedRows,
      pager,
      goToPage,
      loading,
      themeColor,
      searchTerm,
      toggleZoneActive,
      toggleZoneHub,
      toggleZoneStock,
      deleteZone,
      editZone,
      auth,
      formZone,
      submitEditZone
    };
  },
};
</script>

<style scoped>
/* ---------- Page header ---------- */
.pg-page-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(6, 180, 138, 0.1);
  color: #06b48a;
  font-size: 20px;
}

/* ---------- Card ---------- */
.pg-card {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(43, 42, 63, 0.06);
}

.pg-card .card-head {
  border-bottom: 1px solid #f0f0f5;
}

/* ---------- Buttons ---------- */
.pg-btn-primary {
  background: #06b48a;
  padding: 11px 22px;
  border-radius: 8px;
  font-size: 14px;
}

.pg-btn-primary:hover {
  background: #059c78;
  color: #fff;
}

.pg-btn-outline {
  background: transparent;
  border: 1px solid #e2e2ea;
  color: #2b2a3f;
  padding: 10px 22px;
  border-radius: 8px;
  font-size: 14px;
}

.pg-btn-outline:hover {
  background: #f8f8fa;
  border-color: #d5d5e0;
}

/* ---------- Search ---------- */
.pg-search {
  min-width: 260px;
}

.pg-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #a2a1bb;
  font-size: 14px;
}

.pg-search .form-control {
  border-radius: 8px;
  border: 1px solid #e2e2ea;
  height: 44px;
}

.pg-search .form-control:focus {
  border-color: #06b48a;
  box-shadow: 0 0 0 3px rgba(6, 180, 138, 0.12);
}

/* ---------- Table ---------- */
.pg-table thead th {
  background: #f8f8fb;
  color: #8e8da1;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f1f5;
  white-space: nowrap;
}

.pg-table tbody td {
  padding: 12px 16px;
  font-size: 14px;
  color: #2b2a3f;
  border-bottom: 1px solid #f1f1f5;
  vertical-align: middle;
}

.pg-table tbody tr:nth-child(even) td {
  background: #fbfbfd;
}

.pg-table tbody tr:hover td {
  background: #f8fbfa;
}

/* ---------- Status pills ---------- */
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.status-pill-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.status-pill-success {
  background: rgba(6, 180, 138, 0.1);
  color: #06b48a;
}

.status-pill-danger {
  background: rgba(239, 41, 41, 0.1);
  color: #ef2929;
}

.status-pill-warning {
  background: rgba(243, 196, 76, 0.18);
  color: #c9932a;
}

.status-pill-primary {
  background: rgba(101, 96, 240, 0.1);
  color: #6560f0;
}

.status-pill-info {
  background: rgba(31, 177, 230, 0.1);
  color: #1fb1e6;
}

/* ---------- Action icon buttons ---------- */
.pg-icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #eceef1;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #8e8da1;
  transition: all 0.2s ease;
}

.pg-icon-btn-info:hover {
  background: rgba(31, 177, 230, 0.1);
  border-color: transparent;
  color: #1fb1e6;
}

.pg-icon-btn-edit:hover {
  background: rgba(101, 96, 240, 0.1);
  border-color: transparent;
  color: #6560f0;
}

.pg-icon-btn-delete:hover {
  background: rgba(239, 41, 41, 0.1);
  border-color: transparent;
  color: #ef2929;
}

/* ---------- Modal ---------- */
.pg-modal-content {
  border: none;
  border-radius: 14px;
  overflow: hidden;
}

.pg-modal-header {
  background: #f8f8fb;
  border-bottom: 1px solid #f0f0f5;
  padding: 18px 25px;
}

.pg-modal-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(6, 180, 138, 0.1);
  color: #06b48a;
}

.pg-modal-footer {
  border-top: 1px solid #f0f0f5;
  padding: 16px 25px;
}

.pg-modal-footer .pg-btn-primary,
.pg-modal-footer .pg-btn-outline {
  padding: 9px 20px;
}

/* ---------- Loading skeleton ---------- */
.skeleton-table {
  padding: 10px 0;
}

.skeleton-row {
  padding: 12px 0;
  border-bottom: 1px solid #f1f1f1;
  gap: 20px;
}

.skeleton-cell {
  flex: 1;
}

.skeleton-bar {
  display: block;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #eef0f2 25%, #e2e5e9 37%, #eef0f2 63%);
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.empty-state {
  width: 100%;
}
</style>
